import PlusButton from 'gcs-common/components/PlusButton/PlusButton';
import { LEFT_BAR_TABS } from 'gcs-common/constants/uiFlags';
import { setLeftBarTab } from 'gcs-common/slices/uiState/uiStateSlice';
import { useDispatch } from 'react-redux';

const NewChatButton = () => {
  const dispatch = useDispatch();

  const openNewChannel = () => {
    dispatch(setLeftBarTab({ leftBarTab: LEFT_BAR_TABS.NEW_CHAT }));
  };

  return (
    <div className="ml-4">
      <PlusButton onClick={openNewChannel} iconSize="size-8" />
    </div>
  );
};

export default NewChatButton;
